<body>
    <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
      <div class="row">
        <div class="col-12">                
          <div class="invoice p-3 mb-3"> 

            <div class="row justify-content-center">
                <h6>Fixed Asset Report</h6> 
            </div>

            <!-- Tabele row -->
            <div class="row">
            <div class="col-12">
            <div class="card" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
             <div class="card-body">

               <div class="row pb-2">
                <div class="col-5 input-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-vcard"></i></span>
                    </div>
                    <select [ngClass]="{'dark-bg' : isDark }"  [(ngModel)]="location"  class="form-control">        
                      <option [ngValue]="null">-Select-</option>
                      <option *ngFor="let item of locationList" [value]="item.value">
                        {{item.value}}
                      </option>
                  </select>
                  </div>
              </div>
                <div class="3">
                    <button (click)="viewBtnClicked()" mat-raised-button>View</button>
                    <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                  </div>
                </div>

              <div class="col-12 table-responsive" id="expReport">
                <table class="table" [ngClass]="{'dark-bg' : isDark }">
                  <thead>
                  <tr >                          
                    <th>Asset code</th>
                    <th>Asset Name</th>
                    <th>Category</th>
                    <th>Location</th>
                    <th>PurchaseDate</th>    
                    <th class="text-right">Cost</th>  
                    <th>Init.Qty</th>    
                    <th>UsefulQty</th>  
                    <th>Dis.Qty</th>  
                    <th>CreatedBy</th>                                            
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let item of filteredAssetList">    
                 
                    <td>{{item.AssetCode}}</td>
                    <td>{{item.AssetName}}</td>
                    <td>{{item.Category}}</td>
                    <td>{{item.Location}}</td>  
                    <td>{{item.PurchaseDate | date :'y-MM-dd'}}</td>
                    <td class="text-right">{{item.Cost |  number:'1.2-2'}}</td>     
                    <td class="text-center">{{item.Qty}}</td>  
                    <td class="text-center">{{item.UsefulQty}}</td>  
                    <td class="text-center">{{item.DisposalQty}}</td>  
                    <td>{{item.CreatedBy}}</td>                                                                              
                  </tr>  
                  <tr class="table-active">
                    <td colspan="5" class="text-right text-bold">Total Value of Assets :</td>
                    <td class="text-right text-bold">{{getTotal() | number:'1.2-2'}}</td>
                    <td colspan="4"></td>
                  </tr>                                              
                  </tbody>
                </table>
              </div>
              <!-- /.col -->
             </div>
            </div>
            </div>
            </div>
            <!-- /.row -->


            <!-- this row will not appear when printing -->
            <div class="row no-print">
              <div class="col-12">
                <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
                <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                 <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                            
              </div>
            </div>


          </div><!-- /.invoice -->                 
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->        
</body>







